module.exports = __webpack_public_path__ + "img/kd-logo.98158eee.svg";